import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import cn from 'classnames';

import { Animations } from '../../../../utils/animations';
import { MenuContext } from '../menuManager/menuManager';

import { MenuStyles } from '../../../../styles/styles';
import './menuContent.scss';

import { fab } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
library.add(fab);

const MenuContent = () => {
  const { open } = useContext(MenuContext);
  const { transition, opacityReveal, angleTextReveal } = Animations();

  return (
    <div className="menu-holder">
      <div className={cn('menu-inside', { open })}>
        <div className="menu-nav-container">
          <MenuStyles
            initial={{ backgroundColor: '#0f0e0e', pointerEvents: 'none' }}
            animate={{ backgroundColor: 'transparent', pointerEvents: 'unset' }}
            exit={{
              opacity: [1, 1, 0],
              transition: { duration: 2, times: [0, 0.99, 1] },
            }}>
            <div className="left">
              <div className="left-top"></div>
              <div className="left-bottom">
                <motion.a
                  className="tap-highlight-transparent"
                  variants={opacityReveal}
                  initial="initial"
                  animate="animate"
                  transition={{ ...transition, duration: 1, delay: 3.5 }}
                  href="https://www.linkedin.com/in/shaquille-ndunda/"
                  target="_blank"
                  rel="noreferrer">
                  <FontAwesomeIcon icon={['fab', 'linkedin']} />
                </motion.a>
                <motion.a
                  className="tap-highlight-transparent"
                  variants={opacityReveal}
                  initial="initial"
                  animate="animate"
                  transition={{ ...transition, duration: 1, delay: 3.7 }}
                  href="https://github.com/shaqdeff"
                  target="_blank"
                  rel="noreferrer">
                  <FontAwesomeIcon icon={['fab', 'github']} />
                </motion.a>
              </div>
            </div>

            <div className="right">
              <div className="right-bottom">
                <motion.div className="link-container">
                  <motion.div
                    className="link-wrapper tap-highlight-transparent"
                    variants={angleTextReveal}
                    initial="initial"
                    animate="animate"
                    transition={{ ...transition, duration: 1, delay: 2 }}>
                    <Link to="projects">
                      <span className="number">01.</span>Projects
                    </Link>
                  </motion.div>
                </motion.div>
                <motion.div className="link-container">
                  <motion.div
                    className="link-wrapper tap-highlight-transparent"
                    variants={angleTextReveal}
                    initial="initial"
                    animate="animate"
                    transition={{ ...transition, duration: 1, delay: 2.5 }}>
                    <Link to="about">
                      <span className="number">02.</span>About
                    </Link>
                  </motion.div>
                </motion.div>
                <motion.div className="link-container tap-highlight-transparent">
                  <motion.div
                    className="link-wrapper"
                    variants={angleTextReveal}
                    initial="initial"
                    animate="animate"
                    transition={{ ...transition, duration: 1, delay: 2.7 }}>
                    <a href="mailto:shaquillendunda@gmail.com">
                      <span className="number">03.</span>Contact
                    </a>
                  </motion.div>
                </motion.div>
              </div>
            </div>
          </MenuStyles>
        </div>
      </div>
    </div>
  );
};

export default MenuContent;
